import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store';
import fetchAPI from '../../../common/fetchAPI';
import { EmployeeTaskStateClass } from './interfaces/employeeClass';
import { determineDueStatus } from '../../../common/timeLiveFunction';

const initialState: EmployeeTaskStateClass = {
    isLoading: true,
    isCanvasLoading: false,
    isCanvasOpen: false,
    status: 'idle',
    accountEmployeeId: 0,
    isReload: false,
    timeEntryFormat: 'Time',
    ////////
    employeeTaskList: [],
    //pagination
    startRec: 0,
    search: '',
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    recordsFiltered: 0,
    isSearch: false,
    isShowGrid: false
}

interface IThunkApi {
    state: {
        employeeTask: EmployeeTaskStateClass;
    }
}

export const getAccountProjectTaskHierarchyForEmployeeDetail = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/V2/getAccountProjectTaskHierarchyForEmployeeDetail',
        async (arg, thunkApi) => {
            //const { accountEmployeeId } = thunkApi.getState().employeeTask;
            const response = await fetchAPI(`api/V2/Employees/AccountProjectTaskHierarchyForEmployeeDetail/${arg}`, `Get`, '', true, "");
            const json = await response.json();
            return json;
        }
    )

export const employeeTaskSlice = createSlice({
    name: 'employeeTask',
    initialState,
    reducers: {
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageNo = action.payload.pageNumber;
            state.startRec = action.payload.start;
            state.search = action.payload.search;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateIsCanvasLoading: (state, action: PayloadAction<boolean>) => {
            state.isCanvasLoading = action.payload;
        },
        checkedState: (state, action) => {
            const currentindex = state.employeeTaskList.findIndex((item) => item.AccountProjectTaskId == action.payload);
            const newArray = [...state.employeeTaskList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.employeeTaskList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.employeeTaskList.findIndex((item) => item.AccountProjectTaskId == action.payload);
            const newArray = [...state.employeeTaskList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.employeeTaskList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.employeeTaskList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.employeeTaskList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.employeeTaskList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.employeeTaskList = newArray;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountProjectTaskHierarchyForEmployeeDetail.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountProjectTaskHierarchyForEmployeeDetail.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.employeeTaskList = [];
                }
                else {
                    state.employeeTaskList = payload.Data;
                    state.employeeTaskList.map((item: any) => {
                        item.isSelected = 0;
                        item.deadlineStatus = determineDueStatus(item.DeadlineDate, item.StartDate)
                    });
                }
                state.isLoading = false;
            })
            .addCase(getAccountProjectTaskHierarchyForEmployeeDetail.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})

export const {
    updatePagination,
    updateSearchPagination,
    updateIsLoading,
    updateIsCanvasLoading,
    checkedAllState,
    unCheckedAllState,
    checkedState,
    unCheckedState
} = employeeTaskSlice.actions
export const EmployeeTaskState = (state: RootState) => state.employeeTask
export default employeeTaskSlice.reducer